var map = {
	"./de/animals.json": [
		"00ab",
		"chunk-2d0a3317"
	],
	"./de/cars.json": [
		"d084",
		"chunk-2d21d13e"
	],
	"./de/city-country.json": [
		"1cae",
		"chunk-2d0b66ec"
	],
	"./de/food.json": [
		"8632",
		"chunk-2d0de6d3"
	],
	"./de/literature.json": [
		"de43",
		"chunk-2d2297b6"
	],
	"./de/people.json": [
		"ce48",
		"chunk-2d22235c"
	],
	"./de/sports.json": [
		"750e",
		"chunk-2d0d6e89"
	],
	"./de/things.json": [
		"5cfe",
		"chunk-2d0d3903"
	],
	"./de/tv.json": [
		"dd25",
		"chunk-2d2293b9"
	],
	"./de/web.json": [
		"6320",
		"chunk-2d0cf2b1"
	],
	"./en/animals.json": [
		"4a04",
		"chunk-2d0cb667"
	],
	"./en/cars.json": [
		"fbb2",
		"chunk-2d237ac2"
	],
	"./en/city-country.json": [
		"8926",
		"chunk-2d0df1fb"
	],
	"./en/food.json": [
		"4c1e",
		"chunk-2d0cbe39"
	],
	"./en/literature.json": [
		"aca1",
		"chunk-2d213888"
	],
	"./en/people.json": [
		"126f",
		"chunk-2d0aa9c7"
	],
	"./en/sports.json": [
		"e434",
		"chunk-2d225406"
	],
	"./en/things.json": [
		"d35e",
		"chunk-2d21dc55"
	],
	"./en/tv.json": [
		"7f6e",
		"chunk-2d0e2734"
	],
	"./en/web.json": [
		"5e08",
		"chunk-2d0d39ce"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "bd48";
module.exports = webpackAsyncContext;